export default "__VITE_ASSET__Dz5dM5bA__"